export function sumFieldJsonArray(field, array) {
  let total = 0
  for(let obj of array) {
    let numb
    try {
      if(obj[field] !== null) {
        numb = parseFloat(obj[field])
      }
      else {
        numb = 0
      }
    }
    catch(_) {
      numb = 0
    }
    total += numb
  }
  return total
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/util/dataAgg/sumFieldJsonArray.js